import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
interface ButtonProps extends AntButtonProps {}

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
	return (
		<AntButton
			{...rest}
			className={`${rest?.className ?? ''}`}
		>
			{children}
		</AntButton>
	);
};

export default Button;
